module.exports = __webpack_public_path__ + "img/Olympisk2025.9eacc2da.jpg";